import { render, staticRenderFns } from "./controlBox.vue?vue&type=template&id=2ae4d065&"
import script from "./controlBox.vue?vue&type=script&lang=ts&"
export * from "./controlBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports